import { gql } from '@apollo/client/index.js'
import { useContentful } from '@ecomm/shared-apollo'
import { useMemo } from 'react'
import { reviewSectionSchema } from './schema'

const DEFAULT_REVIEW_SECTION_QUERY = gql`
  query	Review_Section_Query($id: String!, $preview: Boolean!, $locale: String!) {
    reviews(id: $id, locale: $locale, preview: $preview) {
      headline
      reviewsCollection {
        items{
          ... on Review {
            company
            review {
              json
            }
            publishDate
          }
        }
      }
      button {
        ... on Button {
          text
          url
        }
      }
      __typename
    }
  }
`

export const useReviewSectionQuery = (
  id: string,
  QUERY = DEFAULT_REVIEW_SECTION_QUERY
) => {
  const { data: apolloData } = useContentful(QUERY, {
    id
  })

  const reviewSectionData = useMemo(
    () => reviewSectionSchema.parse(apolloData?.['reviews']),
    [apolloData]
  )

  return reviewSectionData
}
